var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main col-xs-12"},[_c('h3',[_vm._v("Accessing restricted resources.")]),_vm._m(0),_c('p',[_vm._v("You will automatically be redirected and logged in. Please wait "+_vm._s(_vm.redirectTimer)+" seconds")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("You must be "),_c('b',[_vm._v("authenticated")]),_vm._v(" before using this application.")])
}]

export { render, staticRenderFns }